import { Trans } from '@lingui/macro'
import { TextField } from '@mui/material'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { datetimeFormat } from 'app/appSettings'
import moment from 'moment'
import { FormLabel } from '../../common/labels/FormLabel'

/**
 * Extended Material UI DateTimePicker that handles portal localization and overriding theme color. Is recommended to use over regular <DateTimePicker /> component.
 * @category Common components
 * @subcategory MUI extended
 * @component
 * @returns {JSX.Element}
 * @property {color} color Focus color of the field
 * @property {function} handleClose Callback fired on inputs onClose event
 * @property {function} handleOpen Callback fired on inputs onOpen event
 */
export const CustomDateTimePicker = ({
  color,
  handleClose,
  handleOpen,
  onChange,
  value,
  ...props
}) => {
  const placeholderValue = value ? moment.utc(value) : moment.utc()

  return (
    <>
      <DateTimePicker
        {...props}
        value={value ? moment.utc(value) : placeholderValue}
        inputFormat={datetimeFormat}
        renderInput={(props) => {
          return (
            <TextField
              {...props}
              inputProps={{
                ...props.inputProps,
                value: value ? props.inputProps.value : '',
                placeholder: ''
              }}
              fullWidth
              variant='outlined'
            />
          )
        }}
        dayOfWeekFormatter={(day) => day}
        minDate={props.minDate || undefined}
        maxDate={props.maxDate || undefined}
        onChange={(e, keyboard) => {
          if (onChange) {
            onChange(e, keyboard)
          }
        }}
        onOpen={e => {
          if (handleOpen) {
            handleOpen()
          }
        }}
        onClose={e => {
          if (handleClose) {
            handleClose()
          }
        }}
      />
      {props.error && props.metaError && (
        <FormLabel error label={<Trans id={props.metaError?.props?.id} />} />
      )}
    </>
  )
}
